import React, { Component } from 'react';

import ThemePreview from 'components/ThemePreview';
import PreviewInvoice from 'components/PreviewInvoice';

class ThemeGallery extends Component {

    onChange(name) {
        let { input } = this.props;
        input && input.onChange(name);
    }
    render() {
        let { themes, selectedTheme, seller, hideLegacy } = this.props;
        let isOldUser =  seller && !seller.dateCreated;

        return <div className="theme-gallery">
            {seller && isOldUser && !hideLegacy && <div onClick={this.onChange.bind(this, 'default')} className={selectedTheme === 'default' ? "theme-gallery-card deprecated selected" : "theme-gallery-card deprecated"}>
                <div className="deprecation-badge">Deprecated</div>
                <h4>Invoice, Storno and Credit Note</h4>
                <p className="deprecation-warning" style={{fontSize: '12px', color: '#856404', margin: '8px 0'}}>
                    This template is deprecated. Please install a modern template from the gallery.
                </p>
                <small className="moz-preview-not-available">Preview not avaiable for Firefox. Chrome browser is recommended.</small>
                <PreviewInvoice zoom={0.50} id="main" seller={seller} />
            </div>}

            {themes && themes.map((t) => {
                return <div onClick={this.onChange.bind(this, t.name)} className={selectedTheme === t.name ? "theme-gallery-card selected" : "theme-gallery-card"}>
                    <h4>{t.name}
                        <small className="pull-right" title="Document Type. You can change this from Templates->About.">{t.documentType || "all"}</small>
                    </h4>
                    <small className="moz-preview-not-available">Preview not avaiable for Firefox. Chrome browser is recommended.</small>
                    <ThemePreview key={t.name} locked={true} zoom={0.40} theme={t} />
                </div>
            })}

        </div>
    }
}

export default ThemeGallery;


// WEBPACK FOOTER //
// app/components/ThemeGallery.jsx